module.exports = __webpack_public_path__ + "static/yoon-bab62814def2ca1e229a8772feb7fde2.png";